import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ExternalLink, Instagram, Facebook } from "lucide-react";
import { useTranslation } from 'react-i18next';

interface ShareLinksProps {
  storeUrl: string;
  onCopy: (text: string) => void;
  onFacebookShare: () => void;
  onInstagramEdit: () => void;
}

export const ShareLinks = ({
  storeUrl,
  onCopy,
  onFacebookShare,
  onInstagramEdit,
}: ShareLinksProps) => {
  const { t } = useTranslation();
  
  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle>{t('marketing.shareServicePageLink')}</CardTitle>
        <CardDescription>
          {t('marketing.shareServicePageDesc')}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="flex-1 flex items-center gap-2 min-w-0 w-full break-all md:break-normal">
            <ExternalLink className="h-5 w-5 text-gray-400 flex-shrink-0" />
            <span className="text-gray-600 truncate text-sm md:text-base w-full">{storeUrl}</span>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={() => onCopy(storeUrl)}
            className="w-full md:w-auto mt-2 md:mt-0"
          >
            <ExternalLink className="h-4 w-4 mr-2" />
            {t('marketing.copy')}
          </Button>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center gap-3 flex-1 w-full">
            <Instagram className="h-6 w-6 text-gray-600 flex-shrink-0" />
            <span className="flex-1">{t('marketing.addLinkInBio')}</span>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={onInstagramEdit}
            className="w-full md:w-auto mt-2 md:mt-0"
          >
            <ExternalLink className="h-4 w-4 mr-2" />
            {t('marketing.link')}
          </Button>
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center gap-4 p-4 bg-gray-50 rounded-lg">
          <div className="flex items-center gap-3 flex-1 w-full">
            <Facebook className="h-6 w-6 text-gray-600 flex-shrink-0" />
            <span className="flex-1">{t('marketing.shareOnFacebook')}</span>
          </div>
          <Button 
            variant="outline" 
            size="sm"
            onClick={onFacebookShare}
            className="w-full md:w-auto mt-2 md:mt-0"
          >
            <ExternalLink className="h-4 w-4 mr-2" />
            {t('marketing.share')}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};
